import React, {useState} from "react";
import {Select, Form} from "antd";
import {RangePickerProps} from "antd/es/date-picker";
import LuxonDatePicker from "../../form-controls/LuxonDatePicker";
import {DateTime} from "luxon";
const {RangePicker} = LuxonDatePicker;

type DateRangePickerProps = Omit<RangePickerProps, 'onChange' | 'value'> & {
  onStartDateChange?: (value: DateTime) => void;
  onEndDateChange?: (value: DateTime) => void;
  startDateValue?: DateTime;
  endDateValue?: DateTime;
  rangeSelectionBehavior?: 'future' | 'past';
  format?: string;
}

export default function DateRangePicker(props: DateRangePickerProps) {
  const [dateRange, setDateRange] = useState<string>('');
  

  const updateDateRange = (value: '-1' | '' | '1' | '3' | '6' | '12') => {
    const direction = props.rangeSelectionBehavior === 'future' ? 1 : -1;

    setDateRange(value);
    if (value === '') {
      props?.onStartDateChange?.(null);
      props?.onEndDateChange?.(null);
      return;
    }

    const currentDate = DateTime.now();
    let targetDate: DateTime = value == "-1"
      ? currentDate.plus({weeks: 1 * direction})
      : currentDate.plus({months: Number.parseInt(value) * direction});

    const startDate = currentDate < targetDate ? currentDate : targetDate;
    const endDate = currentDate < targetDate ? targetDate : currentDate;

    props?.onStartDateChange?.(startDate);
    props?.onEndDateChange?.(endDate);
  }

  const Footer = () => {
    const direction = props.rangeSelectionBehavior === 'future' ? '(future)' : '(past)';

    return (
      <>
        <Form.Item label='Date Range' style={{paddingBlock: 8}}>
          <Select
            defaultValue=''
            value={dateRange}
            onSelect={updateDateRange}
            options={[
              {label: 'User Defined', value: ''},
              {label: `1 Week ${direction}`, value: '-1'},
              {label: `1 Month ${direction}`, value: '1'},
              {label: `3 Months ${direction}`, value: '3'},
              {label: `6 Months ${direction}`, value: '6'},
              {label: `12 Months ${direction}`, value: '12'},
            ]}
          />
        </Form.Item>
      </>
    )
  }

  const handleOnChange = (values: [DateTime, DateTime]) => {
    props.onStartDateChange?.(values?.[0]);
    props.onEndDateChange?.(values?.[1]);

    setDateRange('');
  }

  return (
    <RangePicker
      onChange={handleOnChange}
      value={[
        props.startDateValue,
        props.endDateValue
      ]}
      renderExtraFooter={() => <Footer />}
      format={props.format ?? "DD/MM/YYYY"} 
    />
  )
}
